@if (medals().length > 0) {
    <ul class="awards">
        @for (award of medals(); track award.id) {
            <li class="award">
                <!-- Our own glyph. Competition medals and logos are never rendered. -->
                <span class="award-glyph" aria-hidden="true">
                    <svg width="30" height="30" viewBox="0 0 32 32" fill="none"
                         xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 12.8a6.6 6.6 0 1 1 0 13.2 6.6 6.6 0 0 1 0-13.2Z"
                              fill="currentColor" fill-opacity=".22"/>
                        <path d="M16 12.8a6.6 6.6 0 1 1 0 13.2 6.6 6.6 0 0 1 0-13.2Z"
                              stroke="currentColor" stroke-width="1.7"/>
                        <path d="M11.4 10.6 8.4 4h15.2l-3 6.6" stroke="currentColor"
                              stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </span>

                <span class="award-body">
                    <b class="award-result">{{ award.result }}</b>
                    <span class="award-competition">{{ award.competition }}</span>
                    @if (award.editionYear) {
                        <i class="award-year">{{ award.editionYear }}</i>
                    }
                </span>
            </li>
        }
    </ul>
}

@if (scores().length > 0) {
    <!--
      Deliberately a separate list under its own heading: an external score is somebody else's
      rating on somebody else's scale and must never be read as part of our sensory profile.
    -->
    <div class="external-scores">
        <p class="external-scores-title">{{ 'editorial.external_score' | translate }}</p>
        @for (score of scores(); track score.id) {
            <p class="external-score">
                <b class="score-number">{{ score.score }}<i>{{ score.scale }}</i></b>
                <span class="score-competition">{{ score.competition }}</span>
                @if (score.editionYear) {
                    <span class="score-year">· {{ score.editionYear }}</span>
                }
            </p>
        }
    </div>
}
